import React from "react";
import useDoko from "@anomalyhq/use-doko";

const DokoProvider = ({ children }) => {
  useDoko({
    env: "production",
    title: "Anomaly Software",
    subtitle: "https://www.anomaly.net.au",
    facts: [
      {
        key: "Server",
        value: "Netlify",
      },
    ],
    report: "https://github.com/anomaly/anomaly.net.au/issues/new",
  });
  return children;
};

const dokoProvider = ({ element }) => {
  return <DokoProvider>{element}</DokoProvider>;
};

export default dokoProvider